<template>
	<b-overlay :show="is_load" rounded="sm">
		<h5 class="frame-heading">{{__t('PROD_REST_HEAD')}}</h5>
		<div class="panel-tag">
            {{__t('PROD_REST_TAG')}}
		</div>

		<div class="rest_table">
			<b-table head-variant="dark"
					 :thead-class="head_class"
					 :tbody-tr-class="rowClass"
					 striped
					 class="table-responsive-xl resolution_table"
					 :items="worked_rest"
					 :fields="fields">

				<template v-slot:cell(restaurants)="data" >
					<div class="form-group mt-2">
						<label class="form-label" for="advanced_price">
							{{__t('RESTAURANTS')}}
                            <div class="choose_all d-inline cursor-pointer">
                                <i class="fal fa-laptop-code" v-on:click="choose_all(data.index)"></i>
                            </div>
						</label>
						<div class="input-group flex-nowrap">
							<v-select multiple
									  v-model="data.item.restaurants"
                                      @input="set_restaurants"
									  class="imc_reasons"
									  label="title"
									  :filterable="false"
									  :options=aiko_can_select_restaurants  >
								<template slot="option" slot-scope="option">
									<div class="d-center">
										{{ option.id }}
										<small >{{option.title}}</small>
									</div>
								</template>
							</v-select>
						</div>
					</div>
				</template>

				<template v-slot:cell(id)="data" >
					<i class="fal fa-trash cursor-pointer" v-on:click="remove_rest(data.index)"></i>
				</template>

				<template  v-slot:cell(price)="data" >
					<div class="form-group mt-2">
						<label class="form-label" for="advanced_price">
                            {{__t("PROD_REST_PRICE")}}
						</label>

						<div class="input-group flex-nowrap">
							<div class="input-group-prepend">
								<span class="input-group-text">
									<i class="fal  fa-typewriter fs-xl" ></i>
								</span>
							</div>
							<input id="advanced_price" type="text" class="form-control" v-model="data.item.price">
						</div>
					</div>
				</template>

			</b-table>


			<div class="add_button mt-2">
				<button type="button" v-on:click="push_empty" class="btn btn-lg btn-outline-primary waves-effect waves-themed">
                    {{__t("ADD")}}
                </button>
			</div>
		</div>

	</b-overlay>
</template>

<script>
import vSelect from 'vue-select'

export default {
	name: "product_restaurants",
	props : {
		product : {
			type : Object
		}
	},
	components: {
		vSelect
	},
	created() {
		this.get_restaurants();
	},

	data() {
		return {
			is_load: false,
			restaurants : [],
			//worked_rest : [],
			fields : [
				{
					key : 'restaurants',
					label: this.__t('RESTAURANTS'),
					class:'prod_rest_restaurants'
				},
				{
					key : 'price',
					label : this.__t('PROD_REST_PRICE'),
					class : 'prod_rest_price',
				},

				{
					key : 'id',
					label :' x ',
					class : 'prod_rest_id',
				},
			],
		}
	},

	methods: {

        choose_all(idx) {
            let self = this;
            this.aiko_can_select_restaurants.map(item => {
                self.worked_rest[idx].restaurants.push(item);
                self.worked_rest[idx].restaurants_ids.push(item.id);
            });
        },

        set_restaurants(val) {
            //set ids
            try {
                let cur_val = this.product.restaurants;
                this.product.restaurants.map(item => {
                    let restaurants_in = item.restaurants;
                    item.restaurants_ids = [];
                    restaurants_in.map(rest => {
                        item.restaurants_ids.push(rest.id)
                    });
                });
            }
            catch (e) {
                console.error(e);
            }


        },

		rowClass(item) {

		},

		remove_rest (arr_idx) {
			console.log("remove_item ->",arr_idx);
			this.worked_rest.splice(arr_idx,1);
		},

		push_empty () {
			let empt_rest = {
				id : 0,
				restaurants : [],
                restaurants_ids : [],
				price : 0,
			};

			this.worked_rest.push(empt_rest);

		},

		async get_restaurants() {
			this.is_load = true;
			this.restaurants = [];
			await api.get('/internal/v1/catalog/products/'+parseInt(this.product.id)+'/restaurants').then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					this.restaurants = data.data;
				}
			})
			.catch(({response}) => {
				this.is_load = false;
				this.restaurants = [];
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
			});
		}
	},

	computed : {

		worked_rest () {
            if(this.product.hasOwnProperty('restaurants')) {

                this.product.restaurants.map(item => {
                    item.restaurants = [];
                    if(item.hasOwnProperty("restaurants_ids") && item.restaurants_ids.length > 0) {
                        item.restaurants_ids.map(rest_id => {
                            this.all_restaurants.map(itm => {
                                if(parseInt(rest_id) === parseInt(itm.id)) {
                                    item.restaurants.push(itm);
                                }
                            })
                        });
                    }
                });
                return this.product.restaurants;
            }
            return [];
		},

		head_class() {
			return 'hidden_heade';
		},

		all_restaurants ()  {
			try {
				return this.restaurants;
			}
			catch (e) {

			}

			return [];
		},

		aiko_can_select_restaurants () {
			let res = [];

			this.all_restaurants.map(itm => {
				if(this.selected_rest_ids.length > 0) {
					if(!this.selected_rest_ids.includes(itm.id)) {
						res.push(itm);
					}
				}
				else {
					res.push(itm);
				}
			});

			return res;
		},

		selected_rest_ids () {
			let ins_rest = [];

			if(this.worked_rest.length > 0) {
				this.worked_rest.map(item => {
					if(item.hasOwnProperty("restaurants_ids") && item.restaurants_ids.length > 0) {
						item.restaurants_ids.map(rest_id => {
							if (!ins_rest.includes(parseInt(rest_id))) {
								ins_rest.push(parseInt(rest_id));
							}
						});
					}
				});
			}

			return ins_rest;
		},

	}




}
</script>

<style scoped>


</style>
